import clsx from "clsx";
import { HomeSkeletonBar } from "@/components/home/HomeSkeletonBar";
import { HOME_SURFACE_INSET } from "@/components/home/homeSurfaces";
import {
  HOME_SURFACE_TABLE_HEAD_BORDER,
  HOME_SURFACE_TABLE_ROW_DIVIDER,
} from "@/components/home/HomeSurfaceTable";
import { WORKBENCH_SEARCH_PILL_CLASS } from "@/components/ui/workbench/workbenchSurface";

export type HomeTaskConsoleTableSkeletonProps = {
  testId?: string;
  rowCount?: number;
  showRiskFilter?: boolean;
};

function SkeletonRow() {
  return (
    <tr>
      <td className="px-3 py-3">
        <HomeSkeletonBar className="h-6 w-14 rounded-full" />
      </td>
      <td className="px-3 py-3">
        <HomeSkeletonBar className="h-4 w-[72%]" />
      </td>
      <td className="px-3 py-3">
        <div className="space-y-2">
          <HomeSkeletonBar className="h-4 w-[85%]" />
          <HomeSkeletonBar className="h-3 w-[55%]" />
        </div>
      </td>
      <td className="px-3 py-3">
        <HomeSkeletonBar className="h-4 w-12" />
      </td>
      <td className="px-3 py-3 text-right">
        <HomeSkeletonBar className="ml-auto h-8 w-[5.5rem] rounded-lg" />
      </td>
    </tr>
  );
}

/** Structured loading state for the Needs you task console table. */
export function HomeTaskConsoleTableSkeleton({
  testId = "home-task-console-table",
  rowCount = 5,
  showRiskFilter = true,
}: HomeTaskConsoleTableSkeletonProps) {
  return (
    <div
      className="flex min-h-0 flex-1 flex-col gap-4"
      data-testid={`${testId}-loading`}
      aria-busy
      aria-label="Loading tasks"
    >
      <div className="flex items-center gap-2">
        <div className={clsx(WORKBENCH_SEARCH_PILL_CLASS, "min-w-0 flex-1 px-3 py-2")}>
          <HomeSkeletonBar className="h-4 w-[42%]" />
        </div>
        {showRiskFilter ? <HomeSkeletonBar className="h-10 w-28 shrink-0 rounded-xl" /> : null}
      </div>

      <div
        className={clsx(
          "min-h-0 overflow-hidden rounded-xl",
          HOME_SURFACE_INSET,
        )}
      >
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className={HOME_SURFACE_TABLE_HEAD_BORDER}>
              {["Risk", "Subtask", "Run · client", "Waiting", "Action"].map((label) => (
                <th key={label} className="px-3 py-3">
                  <HomeSkeletonBar className="h-3 w-16" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={HOME_SURFACE_TABLE_ROW_DIVIDER}>
            {Array.from({ length: rowCount }).map((_, index) => (
              <SkeletonRow key={index} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
